export default __webpack_public_path__ + "static/media/K_wdt_c_cap_3.25d9d04e.mp3";